import { Component } from '@angular/core'

@Component({
  template: '<ftr-reset-sent></ftr-reset-sent>',
})
export class ResetSentPage {}
